import { useMemo } from "react";
import { useDialog } from "../../../../utils/hooks/use-dialog";
import { CopyDialog } from "./copy-dialog";
import { CopyWarningDialogWithRename } from "./copy-warning-dialog-with-rename";

import type { CopyDialogProps } from "./copy-dialog";
import type { FC } from "react";

export function useCopyDialogs({ clonable }: { clonable: boolean | "warn_first" }): {
  handleCopy: () => void;
  dialogControl: ReturnType<typeof useDialog>;
  CopyDialogComponent?: FC<CopyDialogProps>;
} {
  const dialogControl = useDialog();
  const dialogComponent = useMemo(
    () => (clonable === "warn_first" ? CopyWarningDialogWithRename : CopyDialog),
    [clonable],
  );

  return {
    handleCopy: dialogControl.handleOpen,
    dialogControl,
    CopyDialogComponent: dialogComponent,
  };
}
